module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fn-title"
  }, [_c('span', [_vm._v("COLGATE & CO’S")])]), _vm._v(" "), _c('p', {
    staticClass: "fn-title1"
  }, [_c('span', [_vm._v("FLAVORING EXTRACTS,")])]), _vm._v(" "), _c('p', {
    staticClass: "fn-title2"
  }, [_c('span', [_vm._v("SUPERIOR")])]), _vm._v(" "), _c('p', {
    staticClass: "fn-title3"
  }, [_c('span', [_vm._v("-"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v("-")])]), _vm._v(" "), _c('p', {
    staticClass: "fn-title2"
  }, [_c('span', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URITY AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TRENGTH.")])])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/fm-line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "fn-title5"
  }, [_c('span', [_vm._v("EXTRACT VANILLA,")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "1",
      "rules": "all",
      "width": "100%;"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right-1"
  }, [_vm._v("”")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("ROSE,")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "5%"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right-1"
  }, [_vm._v("”")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("LEMON,")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "5%"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("ORANGE,")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "5%"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("ALMOND,")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "5%"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("GINGER,")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "5%"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("CELERY.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "5%"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "indent3"
  }, [_vm._v("The same high standard of excellence is observed in the preparation of our Flavoring Extracts which has made "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("all articles")]), _vm._v(" of our manufacture so popular.")]), _vm._v(" "), _c('p', {
    staticClass: "right5"
  }, [_c('span', [_vm._v("Colgate & Co.,")])]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('span', [_vm._v("55 JOHN STREET, N. Y.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fdae06c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter1.vue
// module id = 75
// module chunks = 0